import axiosInstance from "../../data/axiosInstance/axiosInstance";

const VERO_BASE = `${process.env.REACT_APP_API_VERO_URL ?? ''}`.replace(/\/+$/, '');

export const AllegatiService = {
  getCategoria: () => {
    return axiosInstance.get(`${process.env.REACT_APP_API_SINISTRI_URL}/api/v1/bff/denunce/categorie/allegati`);
  },
  getTipologia: (nomeSottoCategoria) => {
    return axiosInstance.get(`${process.env.REACT_APP_API_SINISTRI_URL}/api/v1/bff/denunce/sottocategorie/allegati/${nomeSottoCategoria}`);
  },
  getClaimFilesShortSummary: (claimNumber) => {
    return axiosInstance.get(
      `${VERO_BASE}/api/v1/claims/workflow/files/${encodeURIComponent(claimNumber)}`
    );
  },
  getClaimFileLongSummary: (claimNumber, documentId) => {
    return axiosInstance.get(
      `${VERO_BASE}/api/v1/claims/workflow/files/${encodeURIComponent(claimNumber)}/${encodeURIComponent(documentId)}`
    );
  }
};

export default AllegatiService;
